import { drawerWidth } from '../constants';

const appStyles = {
  container: {
    display: 'flex'
  },
  appBar: {
    zIndex: (theme) => theme.zIndex.drawer + 1,
    bgcolor: '#ffffff',
    boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
    transition: 'all 0.3s ease',
    width: (props) => props.open ? `calc(100% - ${drawerWidth}px - 2rem)` : '91%',
    left: '16.5rem',
    borderRadius: 1,
    margin: '.7rem auto auto auto !important',
    position: 'absolute'
  },
  toolbar: {
    height: { xs: 64, md: 70 },
    px: { xs: 2, md: 3 }
  },
  logo: {
    height: { xs: 55, md: 100 },
    margin: 'auto',
    transition: 'all 0.2s ease',
    position: 'relative'
  },
  title: {
    flexGrow: 1,
    fontWeight: 600,
    fontSize: { xs: '1.1rem', md: '1.25rem' },
    letterSpacing: '-0.01em',
    color: '#696cff'
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    display: { xs: 'none', sm: 'block' },
    '& .MuiDrawer-paper': {
      width: drawerWidth,
      boxSizing: 'border-box',
      bgcolor: '#fff',
      borderRight: '1px solid rgba(0,0,0,0.08)',
      boxShadow: 'none',
      transition: 'all 0.3s ease'
    }
  },
  drawerToolbar: {
    height: { xs: 64, md: 70 }
  },
  drawerContainer: {
    overflow: 'hidden auto', /* Only allow vertical scrolling */
  },
  drawerTitle: {
    color: '#566a7f',
    fontWeight: 600,
    letterSpacing: '0.05em',
    fontSize: '0.75rem',
    ml: '-1rem',
    '&::before': {
      content: '"― "',
      color: '#566a7f'
    }
  },
  drawerList: {
    mt: 1,
  },
  drawerItem: {
    borderRadius: '10px',
    margin: '0 1rem 0 1rem!important',
    color: '#566a7f',
    '&.Mui-selected': {
      bgcolor: '#e7e7ff',
      color: '#696cff!important',
      '& .MuiListItemIcon-root': {
        color: '#696cff!important'
      },
      '& .MuiListItemText-primary': {
        color: '#696cff!important',
        fontWeight: 600
      },
      '&:hover': {
        bgcolor: '#e7e7ff'
      }
    },
    '&:hover': {
      bgcolor: '#f6f6f9'
    },
    transition: 'all 0.2s ease'
  },
  drawerIcon: {
    minWidth: 40
  },
  drawerText: {
    fontSize: '0.95rem',
    color: '#566a7f'
  },
  mainContent: {
    flexGrow: 1,
    p: { xs: 1, sm: 2, md: 3 },
    backgroundColor: '#f5f5f9',
    minHeight: '100vh',
    transition: 'all 0.3s ease'
  },
  pdfContainer: {
    height: 'calc(100vh - 140px)',
    borderRadius: 2,
    overflow: 'visible',
    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
    m: { xs: 1, md: 3 },
    display: 'flex',
    flexDirection: 'column'
  }
};

export default appStyles;